module.exports = __webpack_public_path__ + "img/bg_ag.87905104.jpg";